<template>
	<div class="skill-card">
		<div class="dashboard-chart">
			<design-2021-apprentice-radial-bar-chart-component
				ref="radialChart"
				:series="skillValue"
				:options="chartOptions"
				height="150"
				width="175">
			</design-2021-apprentice-radial-bar-chart-component>
		</div>
		<div class="description">
			{{ skillSkillTreeIn.skill.name }}

			<b-button
				class="btn-show-all btn-skill-stats"
				v-if="rubricFormIn.rubric_formable_id !== 0"
				variant="primary"
				@click="showStats">
				meer
			</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'design-2021-combined-skill-card-component',
		props: {
			skillSkillTreeIn: {
				type: Object,
				required: true,
			},

			rubricFormIn: {
				type: Object,
				required: true,
			},
		},

		data() {
			return {
				chartOptions: {
					chart: {
						height: 150,
						type: 'radialBar',
						sparkline: {
							enabled: true,
						},
					},
					plotOptions: {
						radialBar: {
							inverseOrder: false,
							startAngle: -90,
							endAngle: 270,
							offsetX: 0,
							offsetY: 0,
							strokeLinejoin: 'round',

							hollow: {
								margin: 0,
								size: '70%',
								background: 'transparent',
								strokeLinejoin: 'round',

								position: 'front',
								dropShadow: {
									enabled: false,
									top: 0,
									left: 0,
									blur: 3,
									opacity: 0.5,
								},
							},

							track: {
								background: '#e8eced',
								strokeWidth: '85%',
								margin: 0, // margin is in pixels
							},

							dataLabels: {
								name: {
									show: true,
									offsetY: 6,
									margin: 0,
									fontSize: '14px',
									fontWeight: 700,
								},
								value: {
									show: false,
								},
							},

							stroke: {
								lineCap: 'round',
							},
						},
					},
					labels: this.getLabels(),
                    colors: [function({ value}) {
                        if (value < 26) {
                            return '#FF0046';
                        } else if (value < 51) {
                            return '#fd7e14';
                        } else if (value < 76) {
                            return '#FFD600';
                        } else {
                            return '#61CC13';
                        }
                    }],

				},
			};
		},
		computed: {
			skillValue() {
				if (!this.rubricFormIn.rubric_form_results) {
					return [''];
				}

				return [this.getSkillValue(this.rubricFormIn)];
			},
		},
		methods: {
			getSkillValue(rubricForm) {
				let value =
					(rubricForm.rubric_form_results[0].result / rubricForm.rubric_form_results[0].max_points) * 100;
				return Math.round(value);
			},

			showStats() {
				const statsData = {
					title: this.skillSkillTreeIn.skill.name,
					seriesName: 'Beoordeling',
					seriesData: this.skillSkillTreeIn.rubrics[0].rubric_forms.map((rubricForm) =>
						this.getSkillValue(rubricForm)
					),
					xAxisCategories: this.skillSkillTreeIn.rubrics[0].rubric_forms.map(
						(rubricForm) => rubricForm.created_at
					),
				};

				this.$emit('show-stats', statsData);
			},

			getLabels() {
				if (!this.rubricFormIn.rubric_columns) {
					return [''];
				}

				const skillValue = this.getSkillValue(this.rubricFormIn);
				const needle = this.rubricFormIn.rubric_columns.length;
				const step = Math.round(100 / needle);

				for (let i = 1; i <= needle; i++) {
					if (skillValue <= Math.round(i * step)) {
						return [this.rubricFormIn.rubric_columns[i - 1].title];
					}
				}
			},
		},

		watch: {
			'rubricFormIn.rubric_columns': {
				handler: function (newVal) {
					this.rubricFormIn.rubric_columns = [...newVal];
					this.chartOptions.labels = [...this.getLabels()];
					this.$refs.radialChart.$refs.apexChart.updateOptions(this.chartOptions, true);
				},
				deep: true,
			},
		},
	};
</script>

<style scoped lang="scss">
	.skill-card {
		display: flex;
        flex-direction: column;
		align-items: center;
		justify-content: flex-start;

		.description {
			width: 100%;
			font-size: $base-font-size;
			font-weight: $font-weight-bold;
			flex: 1 1 auto;

			.btn-skill-stats {
				font-size: $default-font-size;
                font-weight: $font-weight-medium;
				margin-top: map-get($grid-gutter-spacing, 'four');
			}
		}

        &:not(:last-child) {
            margin-bottom: $grid-gutter-width;
        }
	}

    @media(min-width: map-get($grid-breakpoints, 'sm')){
        .skill-card {
            flex-direction: row;

            &:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
</style>
